import { DynamicGalleryEnvService } from '@aipb/gulliver/dynamic-gallery/env';
import { ApplicationInitGuard } from '@aipb/gulliver/util-app';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {
  ROUTE_CATEGORY_BREADCRUMB,
  ROUTE_CATEGORY_COLLECTION,
  ROUTE_CATEGORY_ROOT_COLLECTION
} from './dynamic-gallery.constants';

@Injectable()
export class DynamicGalleryInitGuard extends ApplicationInitGuard {
  constructor(protected dynamicGalleryEnv: DynamicGalleryEnvService) {
    super('dynamic-gallery', dynamicGalleryEnv);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const configId = 'configId' in route.params ? route.params['configId'] : 'default';
    this.dynamicGalleryEnv.setActiveConfigId(configId);
    return super.canActivate(route, state);
  }

  override setup() {
    this.frame.setRouteCategories([
      {
        id: ROUTE_CATEGORY_ROOT_COLLECTION,
        label: 'Hlavní kolekce',
        icon: 'folder'
      },
      {
        id: ROUTE_CATEGORY_BREADCRUMB,
        label: 'Navigace',
        icon: 'account_tree'
      },
      {
        id: ROUTE_CATEGORY_COLLECTION,
        label: 'Kolekce',
        icon: 'folder'
      }
    ]);
  }
}
